import React, { useState } from "react"
import * as classNames from "../articlesListBlock/ArticlesListBlock.module.scss"

import ArticleCardBlock from "../article-card/ArticleCardBlock"
import ArticleLeftRightBlock from "../article-left-right/ArticleLeftRightBlock"
import Button from "../../../common/blocks/button/Button"
import { articleUrl } from "../../../../../utils/routeLib"

function ArticleLastListBlock({ articles, page, bigTitle, isAlignLeft }) {

  const [size, setSize] = useState(7)
  return (
    <>
      <React.Fragment>
        <ArticleLeftRightBlock
          bigTitle={bigTitle}
          url={articleUrl(articles[1])}
          article={articles[1]}
        />
        <div className={classNames.articleGrid}>
          {articles.slice(3, size).map((article, j) => (
            <ArticleCardBlock
              key={j}
              url={articleUrl(article)}
              articles={article}
            />
          ))}
        </div>
      </React.Fragment>
      <div className={classNames.btn}>
        <Button
          aspect={"classique"}
          color={"primary"}
          onClick={()=>setSize(size+4)}
        >
          Voir plus
        </Button>
      </div> 
    </>
  )
}
export default ArticleLastListBlock
